const pad = (part) => String(part).padStart(2, "0");

/**
 * YYYY-MM-DD for the day the user is living in. `toISOString()` reports the
 * UTC day, which east of Greenwich files anything entered just after midnight
 * under the day before.
 */
export function localISODate(date = new Date()) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
